import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Loading } from '@library/components/Loading';
import { PATHS } from '@bo-constants/routes';
import { getRoleActiveRoutePaths } from '@bo-utils/routes';
import { selectUserRoles } from '@bo-services/authenticationSlice';
import { useEffect } from 'react';
import { useGetAdminCurrentQuery } from '@bo-services/authenticationApi';
import { useSelector } from 'react-redux';
import { useSplitFlag } from '@bo-hooks/useSplitFlag';

export const Authentication = () => {
  const {
    isLoading: isCurrentLoading,
    isFetching: isCurrentFetching,
    isError,
    isSuccess
  } = useGetAdminCurrentQuery();

  const navigate = useNavigate();
  const location = useLocation();
  const userRoles = useSelector(selectUserRoles);

  const { treatment: availableRoutes } = useSplitFlag({
    flagName: 'BACKOFFICE-active-modules'
  });

  const roleActiveRoutePaths = getRoleActiveRoutePaths({
    availableRoutes,
    userRoles
  });

  const isFetching = isCurrentLoading || isCurrentFetching;
  const hasRoleActivePaths = roleActiveRoutePaths.length > 0;

  const { pathname: pathName } = location;
  const isHomePath = pathName === '/';

  const paths = pathName.split('/');
  const roleMatchPathName = isHomePath ? pathName : `/${paths[1]}`;

  useEffect(() => {
    if (isFetching || (isSuccess && !hasRoleActivePaths)) {
      return;
    }

    if (isError) {
      if (!isHomePath) {
        navigate('/');
      }
      return;
    }

    if (
      [PATHS.SIGN_IN, '/'].includes(pathName) ||
      !roleActiveRoutePaths.includes(roleMatchPathName)
    ) {
      if (roleActiveRoutePaths.includes(PATHS.TRADING)) {
        navigate(PATHS.TRADING);
      } else if (roleActiveRoutePaths.includes(PATHS.PAYMENTS)) {
        navigate(PATHS.PAYMENTS);
      } else navigate(roleActiveRoutePaths[0] || '/');
    }
  }, [
    isFetching,
    isHomePath,
    isSuccess,
    isError,
    hasRoleActivePaths,
    navigate,
    pathName,
    roleActiveRoutePaths,
    roleMatchPathName
  ]);

  if (isFetching) {
    return (
      <div className="self-center">
        <Loading loadingMessage="Loading Dashboard" />
      </div>
    );
  }

  if (isSuccess) {
    if (!hasRoleActivePaths) {
      return (
        <div>
          <div className="text-soClean-100 m-auto w-60 justify-center pt-60 text-5xl">
            Access Denied
          </div>
        </div>
      );
    }
    if (isHomePath) {
      return null;
    }
  }

  return (
    <div className="bg-soFresh-100 h-screen w-screen content-center text-base">
      <Outlet />
    </div>
  );
};
